package com.sweetlime.bingeamigo.model.types

enum class ContentType { MOVIE, SHOW, EPISODE }